import { JetView } from 'webix-jet';
import { countries, devConfig, profile } from 'config/config';

/**
 * Class representing the FilterPromotionalCodesView.
 * @extends JetView
 */
export default class FilterPromotionalCodesView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const left = {
            margin: 5,
            id: 'a9',
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'a9',
                    cols: [
                        {
                            view: 'text',
                            minWidth: 200,
                            name: 'UserId',
                            type: 'number',
                            label: "<span class='icon-drivers-license-o'></span>" + _('ID Usuario'), // User ID label
                            hidden: !devConfig.getPermAction('filterByUser', 'Add'), // Permission check for visibility
                            css: 'prm-filterByUser',
                            labelPosition: 'top',
                            placeholder: _('ID Usuario'), // Placeholder text
                        },
                        {
                            view: 'text',
                            minWidth: 200,
                            name: 'BetId',
                            type: 'number',
                            label: "<span class='icon-drivers-license-o'></span>" + _('ID Apuesta'), // Bet ID label
                            hidden: !devConfig.getPermAction('filterByUser', 'Add'), // Permission check for visibility
                            css: 'prm-filterByUser',
                            labelPosition: 'top',
                            placeholder: _('ID de la apuesta'), // Placeholder text
                        },
                        {
                            view: 'richselect',
                            name: 'CampaignType',
                            minWidth: 200,
                            required: true, // Required field
                            label: "<span class='icon-state'></span>" + _('Tipo campaña:'), // Campaign type label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            options: [
                                {
                                    id: '0',
                                    value: _('Bono'), // Option for Bonus
                                },
                                {
                                    id: '1',
                                    value: _('Torneo'), // Option for Tournament
                                },
                                {
                                    id: '2',
                                    value: _('Sorteo'), // Option for Raffle
                                },
                            ],
                        },
                        {
                            view: 'text',
                            minWidth: 200,
                            name: 'CampaignId',
                            type: 'number',
                            label: "<span class='icon-drivers-license-o'></span>" + _('ID Campaña'), // Campaign ID label
                            hidden: !devConfig.getPermAction('filterByUser', 'Add'), // Permission check for visibility
                            css: 'prm-filterByUser',
                            labelPosition: 'top',
                            placeholder: _('ID de la campaña'), // Placeholder text
                        },
                    ],
                },
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'a4',
                    cols: [
                        {
                            view: 'text',
                            minWidth: 200,
                            name: 'Datepicker',
                            id: 'Datepicker',
                            css: 'reportrange',
                            value:
                                moment().subtract(0, 'days').format('YYYY-MM-DD') +
                                ' - ' +
                                moment().format('YYYY-MM-DD'), // Date range value
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'), // Date label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                        },
                    ],
                },
            ],
        };
        const upper_section = {
            css: 'father-container',
            rows: [
                {
                    margin: 10,
                    cols: [left], // Left section containing filters
                },
            ],
        };
        const buttons = {
            id: 'b2',
            rows: [
                {
                    margin: 10,
                    responsive: 'b2',
                    cols: [
                        { id: 'grav', gravity: 3 },
                        {
                            view: 'button',
                            value: _('Ingresar apuesta'), // Button label for entering bet
                            type: 'form',
                            hidden: !devConfig.getPermAction('addPromotionalSportbook', 'Add'), // Permission check for visibility
                            css: 'prm-addPromotionalSportbook',
                            click: () => {
                                this.app.callEvent('addBet:button', [{}]); // Event call for adding bet
                            },
                        },
                        {
                            view: 'button',
                            value: _('Limpiar'), // Button label for clearing
                            width: screen == 'small' ? 0 : 100,
                            minWidth: 200,
                            click: () => {
                                this.getRoot().clear(); // Clear form values
                            },
                        },
                        {
                            view: 'button',
                            value: _('Consultar'), // Button label for consulting
                            hotkey: 'enter', // Hotkey for the button
                            type: 'form',
                            width: screen == 'small' ? 0 : 100,
                            minWidth: 200,
                            id: 'consultDesk',
                            click: () => {
                                const filterdata = this.getRoot().getValues(); // Get form values
                                if (filterdata['CampaignType'] != '') {
                                    this.app.callEvent(
                                        'balanceAdjustments:filter',
                                        [filterdata], // Event call with filter data
                                    );
                                    $$('b5').collapse(); // Collapse the filter section
                                } else {
                                    webix.message({
                                        title: _('Complete los campos'), // Alert title
                                        type: 'alert-error',
                                        text: _('* Tipo campaña es requerido'), // Alert message
                                    });
                                }
                            },
                        },
                    ],
                },
            ],
        };
        const accordion_section2 = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: true,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'), // Accordion header
                            id: 'b5',
                            body: {
                                padding: 10,
                                rows: [upper_section, buttons], // Upper section and buttons
                            },
                        },
                    ],
                },
            ],
        };
        return {
            view: 'form',
            type: 'clean',
            rows: [
                screen.width > 500 && screen.height > 500
                    ? accordion_section2 // Show accordion on larger screens
                    : { height: 1, width: 0 },
            ],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }

    /**
     * Initializes the view and attaches events.
     * @param {Object} grid - The grid object.
     */
    init(grid) {
        const lang = this.app.getService('locale').getLang(); // Get current language
        $$('Datepicker').attachEvent('onAfterRender', function () {
            devConfig.setDateModal(lang); // Set date modal based on language
        });
    }
}

// FILE DOCUMENTED
